import { requestWithToken } from '../../../utilities/request';

/**
 * 作業員一覧取得API
 * GET /api/private/companies/:company_id/workers/list
 * @param {number}companyId: 会社ID
 * @param {object}param
 */
const fetchWorkerList = (companyId, param) => {
  return requestWithToken({
    method: 'GET',
    url: `/api/private/ccus/companies/${companyId}/workers/list`,
    params: param,
    isQuiet: param.isQuiet || false,
  });
};

/**
 * 作業員取得API
 * GET /api/private/ccus/companies/:company_id/workers/:id
 * @param {number}companyId: 会社ID
 * @param {number}workerId: 作業員ID
 */
const fetchWorkerInfo = (companyId, workerId) => {
  return requestWithToken({
    method: 'GET',
    url: `/api/private/ccus/companies/${companyId}/workers/${workerId}`,
  });
};

/**
 * 作業員登録API
 * POST /api/private/ccus/companies/:company_id/workers
 * @param {number}companyId: 会社ID
 * @param {object}param
 */
const registerWorker = (companyId, param) => {
  return requestWithToken({
    method: 'POST',
    url: `/api/private/ccus/companies/${companyId}/workers`,
    data: param,
  });
};

/**
 * 作業員更新API
 * PATCH /api/private/ccus/companies/:company_id/workers/:id
 * @param {number}companyId: 会社ID
 * @param {number}workerId: 作業員ID
 * @param {object}param
 */
const updateWorker = (companyId, workerId, param) => {
  return requestWithToken({
    method: 'PATCH',
    url: `/api/private/ccus/companies/${companyId}/workers/${workerId}`,
    data: param,
  });
};

/**
 * 作業員削除API
 * DELETE /api/private/ccus/companies/company_id/workers
 * @param {number}companyId: 会社ID
 * @param {object}param
 */
const deleteWorker = (companyId, param) => {
  return requestWithToken({
    method: 'DELETE',
    url: `/api/private/ccus/companies/${companyId}/workers`,
    data: param,
  });
};

/**
 * 作業員データ取り込みチェックAPI
 * POST /api/private/ccus/companies/:company_id/workers/bulk_confirm
 * @param {number}companyId: 会社ID
 * @param {object}param
 */
const captureCheck = (companyId, param) => {
  return requestWithToken(
    {
      method: 'POST',
      url: `/api/private/ccus/companies/${companyId}/workers/bulk_confirm`,
      data: param,
    },
    false
  );
};

/**
 * 作業員データ一括登録API
 * POST /api/private/ccus/companies/:company_id/workers/bulk_update
 * @param {number}companyId: 会社ID
 * @param {object}param
 */
const batchRegister = (companyId, param) => {
  return requestWithToken({
    method: 'POST',
    url: `/api/private/ccus/companies/${companyId}/workers/bulk_update`,
    data: param,
  });
};

/**
 * CCUS技能者情報取得開始API
 * GET /api/private/ccus/worker/begin_fetch
 * @param {object}param
 */
const beginFetchCcusInfo = param => {
  return requestWithToken({
    method: 'GET',
    url: '/api/private/ccus/worker/begin_fetch',
    params: param,
  });
};

/**
 * CCUS技能者情報取得確認API
 * GET /api/private/ccus/worker/fetch
 * @param {object}param
 */
const fetchCcusInfo = param => {
  return requestWithToken({
    method: 'GET',
    url: '/api/private/ccus/worker/fetch',
    params: param,
  });
};

/**
 * CCUS技能者情報再取得開始API
 * GET /api/private/ccus/worker/refetch
 * @param {object}param
 */
const refetchCcusInfo = param => {
  return requestWithToken({
    method: 'GET',
    url: '/api/private/ccus/worker/refetch',
    params: param,
  });
};

/**
 * 労務安全書類項目入力状態取得API
 *  安全書類項目(=要入力項目)(=グリーンファイル入力項目)が
 *  各タブごとに入力されているかどうかを確認する
 * PATCH /api/private/ccus/companies/:company_id/workers/:id
 * @param {number}companyId: 会社ID
 * @param {number}workerId: 作業員ID
 */
const greenFileItemsInputStatus = (companyId, workerId) => {
  return requestWithToken(
    {
      method: 'GET',
      url: `/api/private/ccus/companies/${companyId}/workers/${workerId}/green_file_items_input_status`,
      validateStatus(status) {
        return status === 200;
      },
    },
    false
  );
};

const bulkUpdatePartnerCompanyBranch = (companyId, data, useDefaultCatch) => {
  return requestWithToken(
    {
      method: 'POST',
      url: `/api/private/ccus/companies/${companyId}/workers/bulk_update_partner_company_branch`,
      data,
    },
    useDefaultCatch
  );
};

const getExpiration = (companyId, workerId) => {
  return requestWithToken({
    method: 'GET',
    url: `/api/private/ccus/companies/${companyId}/workers/${workerId}/expiration`,
  });
};

const fetchRankCcus = (companyId, param) => {
  return requestWithToken({
    method: 'GET',
    url: `/api/private/ccus/companies/${companyId}/workers/fetch_rank_ccus`,
    params: param,
  });
};

const WorkerInfoApi = {
  fetchWorkerList,
  fetchWorkerInfo,
  registerWorker,
  updateWorker,
  deleteWorker,
  captureCheck,
  batchRegister,
  beginFetchCcusInfo,
  fetchCcusInfo,
  refetchCcusInfo,
  greenFileItemsInputStatus,
  bulkUpdatePartnerCompanyBranch,
  getExpiration,
  fetchRankCcus,
};

export default WorkerInfoApi;



// WEBPACK FOOTER //
// ./src/services/workers/workerInfo/WorkerInfoApi.js